import React from 'react'

import { Charts } from 'modules/Charts/containers'

const ChartsPage = () => <Charts />

export default ChartsPage
